<template>
  <div class="diagram-bubble-chart">
    <div
      class="diagram-bubble-chart__graph-sec"
      :style="{minHeight:`${lineHeight * lineLen}px`,paddingLeft:`${paddingLeft}px`}"
    >
      <div
        class="diagram-bubble-chart__graph-sec__content"
        :style="{minHeight:`${lineHeight * lineLen}px`}"
      >
        <div class="diagram-bubble-chart__graph-sec__content-bubble-sec">
          <div
            v-for="(bubble,bubbleKey) in eventsList"
            :key="bubbleKey"
            class="diagram-bubble-chart__graph-sec__content-bubble"
          >
            <div
              v-for="(item,itemKey) in bubble"
              :key="itemKey"
              class="diagram-bubble-chart__graph-sec__content-bubble-item"
              :class="[{checked:$_statusCheck(itemKey)}]"
              :style="{top:`-${$_getBubbleIntY(item)}px`,width:`${$_getBubbleSize(item)}px`,height:`${$_getBubbleSize(item)}px`,minWidth:`${bubbleMinSize}px`,minHeight:`${bubbleMinSize}px`,'transform':'translate(0,'+$_getBubbleY(item,lineHeight * lineLen)+'px)',boxShadow:`0 0 4px 0 ${$_getBubbleColor(itemKey,'boxShadow')}`,backgroundImage:`${$_getBubbleColor(itemKey,'backgroundImage')}`,border:`solid 0.8px ${$_getBubbleColor(itemKey,'border')}`}"
            />
          </div>
        </div>
        <div class="diagram-bubble-chart__graph-sec__content-bg">
          <div
            v-for="(bg,bgIndex) in lineLen"
            :key="bgIndex"
            class="diagram-bubble-chart__graph-sec__content-bg-item"
          />
        </div>
        <DiagramTooltip
          :label-width="12"
          :label-height="12"
          :label-radius="6"
          :tooltips="tooltips"
          :length="bottomLabels.length"
          @hover-in="$_setIngHover($event)"
          @hover-out="$_unsetIngHover()"
        />
      </div>
      <DiagramFrequencySec
        :frequency-range="[yMax,0]"
        :title="yTitle"
        :max="lineLen"
        :unit="frequencyUnit"
      />
    </div>
    <div
      class="diagram-bubble-chart__bottom-label-sec"
      :style="{paddingLeft:`${paddingLeft}px`}"
    >
      <div
        v-for="(label,labelIndex) in bottomLabels"
        :key="labelIndex"
        class="diagram-bubble-chart__bottom-label"
      >
        {{ label }}
      </div>
    </div>
    <DiagramSwitchSec
      :padding-left="paddingLeft"
      :title="switchBtnTitle"
      @pre-click="$_switchSecPreClick($event)"
      @next-click="$_switchSecNextClick($event)"
    />
    <DiagramStatusLabel
      :status-items="statusItems"
      :value="itemsChecked"
      :label-width="12"
      :label-height="12"
      :label-radius="6"
      @input="$_statusOnChange($event)"
    />
  </div>
</template>
<script>
export default {
  name: "DiagramBubbleChart",
  props: {
    yTitle: {
      type: String,
      default: "",
    },
    statusItems: {
      type: Array,
      default() {
        return [];
      },
    },
    yMax: {
      type: Number,
      default: 0,
    },
    lineLen: {
      type: Number,
      default: 0,
    },
    bottomLabels: {
      type: Array,
      default() {
        return [];
      },
    },
    eventsList: {
      type: Object,
      default() {
        return {};
      },
    },
    tooltips: {
      type: Object,
      default() {
        return {};
      },
    },
    paddingLeft: {
      type: Number,
      default: 0,
    },
    bubbleMaxSize: {
      type: Number,
      default: 0,
    },
    bubbleMinSize: {
      type: Number,
      default: 0,
    },
    switchBtnTitle: {
      type: String,
      default: "",
    },
    lineHeight: {
      type: Number,
      default: 24,
    },
    frequencyUnit: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    itemsChecked: [],
    ingHover: -1,
  }),
  computed: {
    _getEventsLineUsing() {
      const eventsLineUsing = [];
      this.bottomLabels.forEach((label) => {
        const eventLine = this.eventsList[label];
        if (eventLine) {
          this.itemsChecked.forEach((status, statusIndex) => {
            let itemsCheckedType = this.statusItems.find(
              (item) => item.value === status
            );
            if (eventsLineUsing[statusIndex]) {
              eventsLineUsing[statusIndex].push(
                eventLine[itemsCheckedType.type]
              );
            } else {
              eventsLineUsing[statusIndex] = [
                eventLine[itemsCheckedType.type],
              ];
            }
          });
        } else {
          this.itemsChecked.forEach((status, statusIndex) => {
            if (eventsLineUsing[statusIndex]) {
              eventsLineUsing[statusIndex].push(0);
            } else {
              eventsLineUsing[statusIndex] = 0;
            }
          });
        }
      });
      return eventsLineUsing.reverse();
    },
    _getLineColor() {
      let result = [];
      this.itemsChecked.forEach((itemsChecked) => {
        let itemsCheckedType = this.statusItems.find(
          (item) => item.value === itemsChecked
        );
        result.push(itemsCheckedType.lineColor);
      });
      return result.reverse();
    },
    _getDotColor() {
      let result = [];
      this.itemsChecked.forEach((itemsChecked) => {
        let itemsCheckedType = this.statusItems.find(
          (item) => item.value === itemsChecked
        );
        result.push(itemsCheckedType.dotColor);
      });
      return result.reverse();
    },
  },
  watch: {
    statusItems: {
      deep: true,
      immediate: true,
      handler() {
        this.$_setitemsChecked();
      },
    },
  },
  methods: {
    $_statusCheck(type) {
      let itemsCheckedValue = this.statusItems.find(
        (status) => status.type === type
      ).value;
      let check = false;
      if (this.itemsChecked.includes(itemsCheckedValue)) {
        check = true;
      }
      return check;
    },
    $_setitemsChecked() {
      this.itemsChecked = this.statusItems.map((item) => item.value);
    },
    $_setIngHover(index) {
      this.ingHover = index;
    },
    $_unsetIngHover() {
      this.ingHover = -1;
    },
    $_statusOnChange($event) {
      this.itemsChecked = $event;
    },
    $_getBubbleY(bubble, totalHeight) {
      return ((this.yMax - bubble) / this.yMax) * totalHeight;
    },
    $_getBubbleSize(bubble) {
      return (bubble / this.yMax) * this.bubbleMaxSize;
    },
    $_getBubbleIntY(bubble) {
      const bubbleSize = this.$_getBubbleSize(bubble);
      return bubbleSize < this.bubbleMinSize
        ? this.bubbleMinSize / 2
        : bubbleSize / 2;
    },
    $_getBubbleColor(bubbleType, colorType) {
      let itemsChecked = this.statusItems.find(
        (status) => status.type === bubbleType
      );
      if (colorType === "boxShadow") {
        return itemsChecked.boxShadowColor;
      } else if (colorType === "backgroundImage") {
        return itemsChecked.backgroundImg;
      } else if (colorType === "border") {
        return itemsChecked.borderColor;
      }
      return "";
    },
    $_switchSecPreClick($event) {
      this.$emit("pre-click", $event);
    },
    $_switchSecNextClick($event) {
      this.$emit("next-click", $event);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/diagram-bubble-chart";
</style>